import { BrowserRouter } from 'react-router-dom';
import { KeepAliveOutlet } from '@/components/keep-alive';
import { HandoffCompletePage } from './features/auth/HandoffCompletePage';
import { QueryEditorProvider } from './features/query-editor/QueryEditorProvider';
import { QueryHistoryCacheProvider } from './features/query-history/context/QueryHistoryCacheContext';
import { RootLayout } from './layouts/RootLayout';
import { HANDOFF_COMPLETE_PATH } from './lib/auth/reauth';
import { AppRoutes, PageLoader, keepAliveRoutes } from './routes';

function App() {
  // Rendered before the provider tree on purpose. This route only ever loads in
  // the re-auth popup, where mounting RootLayout would block on /me and trip its
  // own redirect-to-login — inside the popup, defeating the whole flow.
  if (window.location.pathname === HANDOFF_COMPLETE_PATH) {
    return <HandoffCompletePage />;
  }

  return (
    <QueryEditorProvider>
      <QueryHistoryCacheProvider>
        <BrowserRouter>
          <RootLayout>
            <KeepAliveOutlet routes={keepAliveRoutes} fallback={<PageLoader />}>
              <AppRoutes />
            </KeepAliveOutlet>
          </RootLayout>
        </BrowserRouter>
      </QueryHistoryCacheProvider>
    </QueryEditorProvider>
  );
}

export default App;
